import { option } from 'fp-ts';
import { useCatalogContext } from 'modules/catalog/catalogSelector';

export const useCatalogName = () => {
  const { catalog } = useCatalogContext();
  return option.toUndefined(catalog)?.name;
};
